<template>
  <div class="w-full flex justify-center b-b b-grey-50 text-center">
    <base-button
      :aria-checked="`${selected === Filters.STH}`"
      class="flex-1 b-b-4 pb-3"
      :class="selected === Filters.STH ? 'b-brand-2 !b-grey-10 ' : 'b-transparent'"
      @click="changePickupMethod(Filters.STH)"
    >
      <span
        class="text-sm fw-medium "
        :class="{ '': selected === Filters.STH }"
      >
        {{ $t.allItems }}
      </span>
    </base-button>
    <base-button
      :aria-checked="`${selected === Filters.PICKUP}`"
      class="flex flex-1 center b-b-4 pb-3"
      :class="selected === Filters.PICKUP ? 'b-brand-2 !b-grey-10 ' : 'b-transparent'"
      @click="selectPickupMethod"
    >
      <span
        class="text-sm fw-medium "
        :class="{ '': selected === Filters.PICKUP }"
      >
        {{ selectedStore?.name || $t.pickupIn24Hours }}
      </span>
      <vf-icon name="edit" />
    </base-button>
    <dialog-bopis-store-search />
  </div>
</template>

<script lang="ts" setup>
const enum Filters {
  STH = 'sth',
  PICKUP = 'pickup',
}

const modelValue = defineModel<string>()

const { dialogOptions } = useAppConfig().components.filter.pickup

const selected = computed<Filters>(() => modelValue.value ? Filters.PICKUP : Filters.STH)
const { selectedStore } = storeToRefs(useBopisStore())
const { $gtm } = useNuxtApp()

const DialogBopisStoreSearch = createDialog('bopis-store-search', dialogOptions)

const changePickupMethod = (ShippingMethod: Filters) => {
  modelValue.value = ShippingMethod === Filters.PICKUP ? selectedStore.value?.storeid : undefined

  $gtm.push('checkout.onClickDeliveryMethod', ShippingMethod === Filters.PICKUP ? 'BOPIS' : 'STH', {
    shippingStoreId: (ShippingMethod === Filters.PICKUP && selectedStore.value?.storeid) || ''
  })
}

const selectPickupMethod = async () => {
  if (selected.value === Filters.PICKUP || !selectedStore.value) {
    await DialogBopisStoreSearch.keep().open({
      filterBopisStores: true,
      showSaveButton: true
    })
  }

  if (selectedStore.value)
    changePickupMethod(Filters.PICKUP)
}
</script>
